import { formatHexReportDate } from "./time-series.js";
import { formatCommunityReportCopy } from "../../community-report-copy.js";

const CATEGORY_KEYS = Object.freeze({
  animals: "map_animal_report",
  environment: "map_environment_report",
});

export function overlayPopupMarkup(properties = {}, language = "EN") {
  const category = properties.category;
  const categoryKey = CATEGORY_KEYS[category];
  if (!categoryKey) throw new TypeError(`Unknown overlay popup category: ${category}.`);
  return `
    <div class="hex-poc-popup">
      <strong>${formatCommunityReportCopy(language, categoryKey)}</strong>
      <span>${formatCommunityReportCopy(language, "hex_popup_subtype", { value: escapeOverlayHtml(humanizeOverlayValue(properties.subtype, language)) })}</span>
      <span>${formatCommunityReportCopy(language, "hex_popup_severity", { value: escapeOverlayHtml(humanizeOverlayValue(properties.severity, language)) })}</span>
      <span>${formatCommunityReportCopy(language, "hex_popup_date", { date: escapeOverlayHtml(formatHexReportDate(properties.reportDate, language)) })}</span>
    </div>
  `;
}

export function escapeOverlayHtml(value) {
  return String(value ?? "").replace(/[&<>'"]/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "'": "&#39;",
    "\"": "&quot;",
  })[character]);
}

export function humanizeOverlayValue(value, language = "EN") {
  if (typeof value !== "string" || value.trim() === "") return formatCommunityReportCopy(language, "hex_not_specified");
  const localized = formatCommunityReportCopy(language, `map_subtype_${value}`)
    || formatCommunityReportCopy(language, `map_severity_${value}`);
  if (localized) return localized;
  return value.replaceAll("_", " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
